// src/components/ModalConfirmacion.jsx
import React from "react";
import "../styles/ModalConfirmacion.css";

export default function ModalConfirmacion({ abierto, mensaje, onConfirmar, onCancelar }) {
  if (!abierto) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-contenido">
        <p>{mensaje}</p>
        <div className="modal-acciones">
          <button className="accion-btn confirmar" onClick={onConfirmar}>
            Confirmar
          </button>
          <button className="accion-btn cancelar" onClick={onCancelar}>
            Cancelar
          </button>
        </div>
      </div>
    </div>
  );
}
